module.exports = "/images/ge.svg?1144f790f6513758f89209aa4e05a1ff";